import { useState } from "react";
import { FaTicket, FaXmark } from "react-icons/fa6";
import { SelectPppoeUser } from "../../../components/forms/selects/SelectPppoeUser";
import { SelectUser } from "../../../components/forms/selects/SelectUser"; // Import komponen SelectUser
import { TicketService } from "../../../services/TicketService";
import { ModalWraper } from "../../../components/modal/wraper";
import { InputDefault } from "../../../components/forms/InputDefault";
import { TextAreaDefault } from "../../../components/forms/TextAreaDefault";

export const TicketCreate = ({ open, setOpen, refreshData }) => {
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        pppoe_user_id: "",
        title: "",
        description: "",
        note: "",
        schedule: "",
        teknisi: [], // Tambahan state array untuk menampung objek teknisi
    });

    const closeModal = () => {
        setOpen(false);
        setFormData({
            pppoe_user_id: "",
            title: "",
            description: "",
            note: "",
            schedule: "",
            teknisi: [], // Reset teknisi
        });
        setLoading(false);
    };

    // Fungsi untuk menghapus teknisi dari array (chips)
    const handleRemoveTeknisi = (id) => {
        setFormData((prev) => ({
            ...prev,
            teknisi: prev.teknisi.filter((t) => t.id !== id),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.pppoe_user_id) {
            alert("Silakan pilih pelanggan terlebih dahulu.");
            return;
        }

        if (!formData.schedule) {
            alert("Silakan pilih jadwal kunjungan.");
            return;
        }

        try {
            setLoading(true);

            // PASTIKAN HANYA MENGIRIM ID (STRING), BUKAN OBJECT
            const formattedData = {
                pppoe_user_id: formData.pppoe_user_id?.id || formData.pppoe_user_id || "",
                title: formData.title,
                description: formData.description,
                note: formData.note || null,
                schedule: formData.schedule.replace("T", " ") + ":00",

                // Map array object teknisi menjadi array string ID
                teknisi: Array.isArray(formData.teknisi) && formData.teknisi.length > 0
                    ? formData.teknisi.map((t) => t.id || t).filter(Boolean)
                    : undefined,
            };

            console.log("Data yang dikirim ke backend:", formattedData); // Cek di console

            await TicketService.create({ data: formattedData });

            if (refreshData) refreshData();
            closeModal();
        } catch (error) {
            console.error("Gagal membuat tiket:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalWraper
            isOpen={open}
            setIsOpen={setOpen}
            title="Buat Tiket Baru"
            maxWidth={"md:max-w-[1000px]"}
            icon={<FaTicket className="text-cyan-500" />}
        >

            <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    <div className="grid gap-3">
                        {/* Pilih Pelanggan */}
                        <SelectPppoeUser
                            label="Pelanggan"
                            value={formData.pppoe_user_id}
                            onChange={(value) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    pppoe_user_id: value,
                                }))
                            }
                        />

                        {/* Jenis Gangguan & Jadwal Kunjungan */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-xs font-semibold text-slate-400 mb-2 uppercase tracking-wider">
                                    Jenis Gangguan
                                </label>
                                <select
                                    required
                                    className="w-full px-4 py-3 text-sm rounded-xl bg-slate-800/60 border border-slate-700 text-slate-100 focus:outline-none focus:border-indigo-500 transition-colors"
                                    value={formData.title}
                                    onChange={(e) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            title: e.target.value,
                                        }))
                                    }
                                >
                                    <option value="">- Pilih Gangguan -</option>
                                    <option value="Loss Merah">Loss Merah</option>
                                    <option value="Redaman Tinggi">Redaman Tinggi</option>
                                    <option value="SSID Hilang">SSID Hilang</option>
                                    <option value="SSID Lemah">SSID Lemah</option>
                                    <option value="ONT Mati">ONT Mati</option>
                                    <option value="PON Blinking">PON Blinking</option>
                                    <option value="Internet Offline">Internet Offline</option>
                                    <option value="Internet Lemot">Internet Lemot</option>
                                    <option value="Lainnya">Lainnya</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-xs font-semibold text-slate-400 mb-2 uppercase tracking-wider">
                                    Jadwal Kunjungan <span className="text-slate-600 text-[9px]">(Opsional)</span>
                                </label>
                                <input
                                    required
                                    type="datetime-local"
                                    className="w-full px-4 py-3 text-sm rounded-xl bg-slate-800/60 border border-slate-700 text-slate-100 focus:outline-none focus:border-indigo-500 transition-colors"
                                    value={formData.schedule}
                                    onChange={(e) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            schedule: e.target.value,
                                        }))
                                    }
                                />
                            </div>
                        </div>

                        {/* Pilih Teknisi (Multi-Select Logic) */}
                        <div>
                            <label className="block text-xs font-semibold text-slate-400 mb-2 uppercase tracking-wider">
                                Pilih Teknisi{" "}
                                <span className="text-slate-600 text-[9px]">(Opsional)</span>
                            </label>

                            <SelectUser
                                value={formData.teknisi}
                                onChange={(selectedUser) => {
                                    if (selectedUser) {
                                        setFormData((prev) => {
                                            // Cegah duplikat teknisi
                                            const isExist = prev.teknisi.some((t) => t.id === selectedUser.id);
                                            if (isExist) return prev;

                                            // Tambahkan teknisi baru ke dalam array
                                            return {
                                                ...prev,
                                                teknisi: [...prev.teknisi, selectedUser],
                                            };
                                        });
                                    }
                                }}
                                placeholder="Cari dan tambah teknisi..."
                            />

                            {/* Tampilkan Chips Teknisi yang sudah dipilih */}
                            {formData.teknisi.length > 0 && (
                                <div className="flex flex-wrap gap-2 mt-3">
                                    {formData.teknisi.map((tech) => (
                                        <div
                                            key={tech.id}
                                            className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors"
                                            style={{
                                                background: "rgba(99, 102, 241, 0.15)",
                                                border: "1px solid rgba(99, 102, 241, 0.3)",
                                                color: "#a5b4fc", // indigo-300
                                            }}
                                        >
                                            <span>{tech.name}</span>
                                            <button
                                                type="button"
                                                onClick={() => handleRemoveTeknisi(tech.id)}
                                                className="hover:text-white transition-colors"
                                            >
                                                <FaXmark className="text-[10px]" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="grid gap-3">
                        {/* Keterangan Masalah */}
                        <TextAreaDefault
                            id="description"
                            label="Keterangan / Masalah"
                            placeholder="Detail keluhan pelanggan..."
                            value={formData.description}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    description: e.target.value,
                                }))
                            }
                        />

                        {/* Catatan Tambahan */}
                        <TextAreaDefault
                            id="note"
                            label="Catatan Tambahan"
                            SubLabel="(opsional)"
                            placeholder="Detail keluhan pelanggan..."
                            value={formData.note}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    note: e.target.value,
                                }))
                            }
                        />
                    </div>
                </div>




                {/* Action Buttons */}
                <div className="flex gap-3 pt-2">
                    <button
                        type="button"
                        onClick={closeModal}
                        disabled={loading}
                        className="flex-1 py-3 rounded-xl border border-slate-700 text-slate-300 transition-colors hover:bg-slate-800 disabled:opacity-50"
                    >
                        Batal
                    </button>

                    <button
                        type="submit"
                        disabled={loading}
                        className="flex-1 py-3 rounded-xl bg-indigo-600 hover:bg-indigo-500 disabled:bg-slate-700 text-white font-semibold flex items-center justify-center gap-2 transition-colors"
                    >
                        {loading ? "Sedang Menyimpan..." : "Simpan Tiket"}
                    </button>
                </div>
            </form>
        </ModalWraper>
    );
};